import React, { useState } from 'react'
import "./Gallery.css"

//assets
import gallery_thumbnail from "../../assets/gallery_img.png"

//assets2 for gallery setup 
import image1  from "../../assets2/milk quality.jpg"
import image2  from "../../assets2/HAND GETSURE CONTROL WHEEL CHAIR.jpg"
import image3  from "../../assets2/DUAL AXIS SOLAR TRACKING MODEL.jpg"
import image4 from "../../assets2/GUTTER CLEANING ROBOT.jpg"
import image5  from "../../assets2/SMART ENERGY METER.jpg"
import image6  from "../../assets2/COCONUT HUSK REMOVER.jpg"
import image7  from "../../assets2/SMART GANTRY CRANE.jpg"
import image8 from "../../assets2/SMART AGRI ROBOT.jpg"
import image9  from '../../assets2/SOLAR POWER GRASS CUTTER.jpg'
import image10 from "../../assets2/MOTORIZED SHOE POLISH MACHINE.jpg"
import image11 from "../../assets2/smart street light.jpeg"
import image12 from "../../assets2/WhatsApp Image 2025-01-29 at 2.42.23 PM (1).jpeg"
import image13 from "../../assets2/WhatsApp Image 2025-01-29 at 2.42.25 PM.jpeg"
import image14 from '../../assets2/SOLAR POWER DUST CLEANING ROBOT.jpg'
import image15 from '../../assets2/MICRO WIND TURBINE POWER GENERATION IN EV VEHICLE.jpg'
import image16 from '../../assets2/MASK DISPOSABLE ROBOT.jpg'
import image17 from "../../assets2/DUMB SIGN.jpg"
import image18 from "../../assets2/DRAINAGE CLEANING MODEL.jpg"
import image19 from "../../assets2/nwimage1.png"
//gallery component
const Gallery = () => {
 
  //iamges array 
  const images =[
    {id:1, src:image1,category:"iot",description:"Milk quality analysis"},
    {id:2, src:image2,category:"iot",description:"Hand gesture wheel chair"},
    {id:3, src:image3,category:"iot",description:"Dual axis solar tracking"},
    {id:4, src:image4,category:"iot",description:"Gutter cleaning robot"},
    {id:5, src:image5,category:"iot",description:"Smart energy meter"},
    {id:6, src:image6,category:"mechanical",description:"coconut husk peeler"},
    {id:7, src:image7,category:"iot",description:"Smart gantry crane"},
    {id:8, src:image8,category:"iot",description:"Smart agri robot"},
    {id:9, src:image9,category:"iot",description:"Solar power grass cutter"},
    {id:10, src:image10,category:"mechanical",description:"Motorized shoe polish"},
    {id:11, src:image11,category:"iot",description:"Smart street light "},
    {id:12, src:image12,category:"iot",description:"wireless power transfer"},
    {id:13, src:image13,category:"iot",description:"single axis solar tracking"},
    {id:14, src:image14,category:"mechanical",description:"Solar power dust cleaner"},
    {id:15, src:image15,category:"iot",description:"Micro wind turbine"},
    {id:16, src:image16,category:"iot",description:"Mask disposable robot"},
    {id:17, src:image17,category:"iot",description:"Dumb sign"},
    {id:18, src:image18,category:"iot",description:"Drainage cleaning model"},
    {id:19,src:image19,category:"mechanical"}
    
  ]

  //use state for filter category
  const [selectCategory,setSelectCategory] = useState("all")// initial all

  //filter 
  const filteredImages = selectCategory === "all" ? images :
  images.filter(img => img.category === selectCategory)
  return (
    
    <>
    <div className='galleryimg'>
      <img src={gallery_thumbnail} alt="" />
         <div className='textover_image'>
             <p>Gallery</p>
         </div>
       
    </div>
      <div className='three_btns'>
        <button onClick={()=>setSelectCategory("all")}>View all</button>
        <button onClick={()=>setSelectCategory("mechanical")}>View mechanical based</button>
        <button onClick={()=>setSelectCategory("iot")}> View iot based</button>
      </div>
      <div className='gallery_container' >
        {
          filteredImages.map(img => (
            <div key={img.id}className='im1' data-aos="fade-right">
                  <img src={img.src} alt={img.category} />
                  <p>{img.description}</p>
            </div>
          ))
        }
      </div>
    
     </>
  )
}

export default Gallery